import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import Formsy from 'formsy-react';
import { FormsyText, FormsyDate } from 'formsy-material-ui/lib';
import { movedReasonsEndpoint } from '../../../../settings/constants';
import globals from '../../../../globals/communityGlobals';
import TreatmentInstanceDialogHeader from './../TreatmentInstanceDialogHeader/TreatmentInstanceDialogHeader';
import ApiSelector from '../../../../containers/common/selectors/selectorContainer';
import { textFieldStyle, multiLineText, datePickerStyle, common } from '../../../../theme/AllocateBaseTheme';
import { treatmentInstanceDialogActions } from '../TreatmentInstanceDialog';

const errorsLocale = globals.getArea('error');
const locale = globals.getArea('treatments');
const riskMaxLength = 500;
const styles = {
  saveBackButtons: { justifyContent: 'flex-start' },
  enableDisableButtons: { display: 'flex', flexDirection: 'column' },
  occurenceDate: { marginLeft: '16px' },
};

class TreatmentInstanceDialogMoving extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canSubmit: false,
    };

    this.errorMessageRiskMaxLength = {
      maxLength: errorsLocale.getMsg('validationMaxLength', [`${riskMaxLength}`]),
    };
    this.riskValidations = { maxLength: riskMaxLength };
  }

  getTimeSlotsPackage = (treatmentInstance, defaultTimeSlotPackage) =>
    treatmentInstance.timeSlotPackage || defaultTimeSlotPackage;

  enableButton = () => this.setState({ canSubmit: true });

  disableButton = () => this.setState({ canSubmit: false });

  save = model => {
    const { changeDialogAction, moveAtDraft } = this.props;
    changeDialogAction(treatmentInstanceDialogActions.EDIT, {
      moveAtDraft: undefined,
      moveAt: moveAtDraft,
      movedReasonId: model.movedReasonId,
      movedRiskAssessment: model.movedRiskAssessment,
    });
  };

  render() {
    const { onClose, moveAtDraft, dateAt, onBack } = this.props;

    return (
      <Formsy.Form
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onSubmit={this.save}
        style={styles.enableDisableButtons}
      >
        <TreatmentInstanceDialogHeader onClose={onClose}>
          {locale.getMsg('rescheduleTreatment')}
        </TreatmentInstanceDialogHeader>
        <div className="dialog-content">
          <div className="row">
            <div className="col-c6">
              <FormsyDate
                required
                name="originalDate"
                floatingLabelText={locale.getMsg('originalDate')}
                className="date-picker"
                disabled
                value={new Date(dateAt)}
                floatingLabelStyle={common.floatingLabelStyle}
                floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                underlineStyle={common.underlineStyle}
                textFieldStyle={datePickerStyle.textFieldStyle}
                inputStyle={textFieldStyle.inputStyle}
              />
            </div>
            <div className="col-c6" style={styles.occurenceDate}>
              <FormsyDate
                required
                name="occurenceDate"
                floatingLabelText={locale.getMsg('rescheduleDate')}
                className="date-picker"
                disabled
                value={new Date(moveAtDraft)}
                floatingLabelStyle={common.floatingLabelStyle}
                floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                underlineStyle={common.underlineStyle}
                textFieldStyle={datePickerStyle.textFieldStyle}
                inputStyle={textFieldStyle.inputStyle}
              />
            </div>
          </div>
          <div className="row">
            <ApiSelector
              name="movedReasonId"
              endpoint={movedReasonsEndpoint}
              reduxIdentifier="movedReasons"
              required
              className="select-field"
              floatingLabelText={`${locale.getMsg('reschedulingReason')} *`}
              isFetchRequired
            />
          </div>
          <div className="row">
            <FormsyText
              name="movedRiskAssessment"
              required
              multiLine
              fullWidth
              rows={4}
              rowsMax={12}
              validations={this.riskValidations}
              validationErrors={this.errorMessageRiskMaxLength}
              className="formsytext-css"
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              validationColor={textFieldStyle.validationColor}
              style={multiLineText.style}
              inputStyle={multiLineText.inputStyle}
              underlineStyle={multiLineText.underlineStyle}
              underlineFocusStyle={multiLineText.underlineFocusStyle}
              floatingLabelText={`${locale.getMsg('riskAssessment')} *`}
            />
          </div>
        </div>
        <div className="row" style={styles.saveBackButtons}>
          <FlatButton label={locale.getMsg('back')} onClick={onBack} />
          <FlatButton secondary type="submit" label={locale.getMsg('save')} disabled={!this.state.canSubmit} />
        </div>
      </Formsy.Form>
    );
  }
}

TreatmentInstanceDialogMoving.propTypes = {
  dateAt: PropTypes.string.isRequired,
  moveAtDraft: PropTypes.instanceOf(Date).isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  changeDialogAction: PropTypes.func.isRequired,
};

export default TreatmentInstanceDialogMoving;
